// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"f30b0b88","38":"f9ad3820","55":"7047ab19","73":"5af4d810","110":"d1bbec23","152":"11a0ceed","325":"f9f51a7e","532":"b63ac428","684":"38e37dc0","707":"98a9057d","770":"b4e7c354","851":"a8520ba6","950":"740dde52"}[chunkId] + ".chunk.js";
};